/**
 * PlatformARSiteHeaderLanguagesView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait PlatformARSiteHeaderLanguages
 */

import { usePlatformARSiteHeaderLanguagesLogic } from '@/hooks/traits/usePlatformARSiteHeaderLanguagesLogic';
import type { PlatformARSiteHeaderLanguagesConfig } from '@/hooks/traits/usePlatformARSiteHeaderLanguagesLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { PlatformARPlatformView as PlatformARPlatformViewEntity } from '@app/shared';
import { Button } from '@almadar/ui/components';
import { Menu } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface PlatformARSiteHeaderLanguagesViewProps {
  config?: Partial<PlatformARSiteHeaderLanguagesConfig>;
}

export function PlatformARSiteHeaderLanguagesView({ config: propsConfig }: PlatformARSiteHeaderLanguagesViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = usePlatformARSiteHeaderLanguagesLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['PlatformARPlatformView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="PlatformAR" trait="PlatformARSiteHeaderLanguages">
      {slotWriter['main'] === 'INIT' ? (<Menu items={Array.isArray(([{ label: "English" as const, code: "en" as const, href: "/platform" as const }, { href: "/ar/platform" as const, code: "ar" as const, label: "العربية" as const }, { label: "Slovenščina" as const, href: "/sl/platform" as const, code: "sl" as const }]).map((entry) => ({ icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : ""), label: (getNestedValue(entry, "label") ?? ""), id: (getNestedValue(entry, "code") ?? ""), href: (getNestedValue(entry, "href") ?? "") }))) ? (((([{ label: "English" as const, code: "en" as const, href: "/platform" as const }, { href: "/ar/platform" as const, code: "ar" as const, label: "العربية" as const }, { label: "Slovenščina" as const, href: "/sl/platform" as const, code: "sl" as const }]).map((entry) => ({ icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : ""), label: (getNestedValue(entry, "label") ?? ""), id: (getNestedValue(entry, "code") ?? ""), href: (getNestedValue(entry, "href") ?? "") }))) as EntityRow[]) as ({ badge?: string | number; disabled?: boolean; event?: string; href?: string; icon?: string; id?: string; label: string; onClick?: never; subMenu?: never[]; title?: string; type?: 'item' | 'divider'; url?: string; variant?: 'default' | 'danger' })[]) : []} trigger={<Button icon="globe" variant="ghost" label={String(__locale.toUpperCase())} size="sm" />} className={((([{ code: "en" as const, href: "/platform" as const, label: "English" as const }, { label: "العربية" as const, code: "ar" as const, href: "/ar/platform" as const }, { href: "/sl/platform" as const, label: "Slovenščina" as const, code: "sl" as const }]).length === 0)) ? "hidden" : ""} position="bottom-end" />) : null}
    </TraitScopeProvider>
  );
}

export default PlatformARSiteHeaderLanguagesView;
